export function getCircularDependencyReplacer() {
    const valueSeen = new WeakSet();
    return function (_key, value) {
        if (typeof value === 'object' && value !== null) {
            if (valueSeen.has(value)) {
                return null;
            }
            valueSeen.add(value);
        }
        return value;
    };
}
export function stringifyExternalJson(json = {}) {
    return JSON.stringify(json !== null && json !== void 0 ? json : {}, getCircularDependencyReplacer());
}
//# sourceMappingURL=json.js.map